export type BudgetRuleAssociatedCampaign = {
  campaignId: string;
  campaignName?: string;
  ruleStatus?: string;
};

/** Normalize Amazon campaign ids for Set lookups (SP string vs SD numeric JSON). */
export function normalizeCampaignId(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value).trim();
}

export function buildLinkedCampaignIdSet(
  associated: BudgetRuleAssociatedCampaign[],
  extraIds: Iterable<unknown> = []
): Set<string> {
  const set = new Set<string>();
  for (const row of associated) {
    const id = normalizeCampaignId(row.campaignId);
    if (id) set.add(id);
  }
  for (const raw of extraIds) {
    const id = normalizeCampaignId(raw);
    if (id) set.add(id);
  }
  return set;
}

export function extractAssociatedCampaigns(data: unknown): BudgetRuleAssociatedCampaign[] {
  if (!data || typeof data !== 'object') return [];
  const d = data as Record<string, unknown>;
  const inner =
    d.data && typeof d.data === 'object' ? (d.data as Record<string, unknown>) : d;
  const list = inner.associatedCampaigns;
  if (!Array.isArray(list)) return [];
  return list
    .filter((x): x is Record<string, unknown> => !!x && typeof x === 'object')
    .map((row) => ({
      campaignId: normalizeCampaignId(row.campaignId ?? row.campaign_id),
      campaignName:
        typeof row.campaignName === 'string'
          ? row.campaignName
          : typeof row.campaign_name === 'string'
            ? row.campaign_name
            : undefined,
      ruleStatus:
        typeof row.ruleStatus === 'string'
          ? row.ruleStatus
          : typeof row.rule_status === 'string'
            ? row.rule_status
            : undefined,
    }))
    .filter((c) => c.campaignId);
}
